import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Vite fires this event when an older browser/CDN bundle references a chunk
// that no longer exists after a deployment. Without handling it, React.lazy
// rejects and the user sees a blank page. Reload once to retrieve the current
// index and asset references.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();

  const storageKey = 'schleishare-vite-preload-reload';
  const lastReload = Number(sessionStorage.getItem(storageKey) || 0);
  const now = Date.now();

  if (!lastReload || now - lastReload > 15000) {
    sessionStorage.setItem(storageKey, String(now));
    window.location.reload();
  }
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
